import { render, staticRenderFns } from "./KerbTopping.vue?vue&type=template&id=e5f8d4e0"
import script from "./KerbTopping.vue?vue&type=script&lang=js"
export * from "./KerbTopping.vue?vue&type=script&lang=js"
import style0 from "./KerbTopping.vue?vue&type=style&index=0&id=e5f8d4e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports